import lrCodeEditor from './_src/lrCodeEditor.vue'

lrCodeEditor.install = function(Vue) {
  Vue.component(lrCodeEditor.name, lrCodeEditor)
}

export default lrCodeEditor